import { createContext, useReducer } from "react";

export const KvkkContext = createContext();

export const kvkkReducer = (state, action) => {
    switch (action.type) {
        case 'SET_KVKK':
            return {
                kvkk: action.payload
            }
        case 'CREATE_KVKK':
            return {
                kvkk: [action.payload, ...state.kvkk]
            }
        case 'DELETE_KVKK':
            return {
                kvkk: state.kvkk.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const KvkkContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(kvkkReducer, {
        kvkk: null
    });

    return (
        <KvkkContext.Provider value={{ ...state, dispatch }}>
            {children}
        </KvkkContext.Provider>
    );
};